import React, { useCallback, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { NotificationService, NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_SUCCESS } from 'ui-components/services/notification-service';
import { getUserFriendlyMessagesForErrorResponse } from '../../../errors/user-friendly-error-message-service';
import { useModal } from '../../../hooks/use-modal';
import ShipFromModal from '../../../ship-from/modals/';
import { trackShipFromConfigStart } from '../../../ship-from/tracking-events';
import { useShipFromPageErrorContext } from './contexts/ship-from-page-error-context-provider';
import messages from './messages';
import style from './style.module.less';
import useFetchShipFroms from './use-fetch-ship-froms';
import { EventSourceStrings } from '../../../tracking/tracking-constants';

export const AddShipFromButton = ({ shouldAutoOpen = false, prefillAddress = null }) => {
  const { open, close, isOpen } = useModal();
  const { setErrors } = useShipFromPageErrorContext();
  const { fetchShipFroms } = useFetchShipFroms();
  const wasOpenedFromShippyRef = useRef(false);

  const onSuccess = useCallback(async () => {
    try {
      close();
      await fetchShipFroms();
      NotificationService.showNotification({
        notificationType: NOTIFICATION_TYPE_SUCCESS,
        title: <FormattedMessage {...messages.addShipFromSuccessMessageTitle} />,
        content: '',
        duration: NOTIFICATION_DURATIONS.SHORT,
      });
    } catch (error) {
      const userFriendlyErrors = getUserFriendlyMessagesForErrorResponse(error)?.errors || [];
      setErrors(userFriendlyErrors);
    }
  }, [fetchShipFroms, close, setErrors]);

  useEffect(() => {
    if (shouldAutoOpen) {
      wasOpenedFromShippyRef.current = true;
      open();
      trackShipFromConfigStart(EventSourceStrings.SHIPPY_ASSISTANT);
    }
  }, [shouldAutoOpen, open]);

  const onClick = useCallback(() => {
    wasOpenedFromShippyRef.current = false;
    open();
    trackShipFromConfigStart(EventSourceStrings.SETTINGS_SHIP_FROM_LOCATIONS);
  }, [open]);

  return (
    <>
      <Button className={style['add-button']} onClick={onClick} theme='primary'>
        <FormattedMessage {...messages.addNewShipFrom} />
      </Button>
      {isOpen && (
        <ShipFromModal
          onClose={close}
          onSuccess={onSuccess}
          prefillAddress={prefillAddress}
          source={wasOpenedFromShippyRef.current ? EventSourceStrings.SHIPPY_ASSISTANT : EventSourceStrings.SETTINGS_SHIP_FROM_LOCATIONS}
        />
      )}
    </>
  );
};
